import Client from "@/http/client";
import { SupportFeatureAnalyticsDto } from "@/http/dto/featureAnalytics";

export class SupportFeatureAnalytics {
  static async getIssueStatusDashboard(params: {
    periodDays: number;
    hotelObjectId?: string;
  }) {
    return await Client.get<SupportFeatureAnalyticsDto>(
      "/v2/supporter/feature-analytics/issue-status-dashboard",
      params,
    );
  }
}
